let requireContext = require.context('./', true, /.+\.js$/)
let utils = {}
let reg = /\.\/(.+)\.js/i
requireContext.keys().forEach(key => {
    let name = key.match(reg)[1]
    if (name !== 'index') {
        utils[name] = requireContext(key).default
    }
})

export default utils